var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"loading":_vm.loading,"border":"","stripe":"","columns":_vm.talbeColumns,"data":_vm.tableList,"height":"400px","width":"300px"},on:{"on-selection-change":_vm.tableSelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }